import Grid from '../Grid/Grid';
import SearchAndFilter from '../SearchAndFilter/SearchAndFilter';
import TextCard from '../TextCard/TextCard'
import styles from './ExtensionListContent.module.css'

const filterOptions = [
    { value: 'filtro1', label: 'Cursos' },
    { value: 'filtro2', label: 'Prestação de serviços' },
    { value: 'filtro3', label: 'Consultoria' },
    { value: 'filtro4', label: 'Ver Todos' }
];

function ExtensionListContent() {
    const elements = Array.from({ length: 18 }, (v, k) => <TextCard seeMore='Saiba Mais' title='Título do Projeto' description='Lorem Ipsum é simplesmente uma simulação de texto da indústria tipográfica e de impressos, e vem sendo utilizado desde o século XVI, quando um impressor desconhecido pegou uma bandeja de tipos e os embaralhou para fazer um livro de ' type='extension' />);
    return (

        <div className={styles.container} data-testid="extension-list-content">

            <div className={styles.title}>Extensões</div>

            <SearchAndFilter filterList={filterOptions} />

            <Grid items={elements} />

        </div>
    )
}

export default ExtensionListContent